import React, { PureComponent } from 'react'
import { ImageRow, RegularCol, RegularRow } from '../../utils/Grid'
import WidgetContainer from '../../containers/WidgetContainer'
import ArticleImageBox from './StyledArticleImageBox'
import ArticleList from './StyledArticleList'
import ArticleListBox from './StyledArticleListBox'
import UTM from '../../utils/UTM'
import { type ArticlesWidgetProps } from './Types'

export default class Articles extends PureComponent<ArticlesWidgetProps> {
  render () {
    const {
      isOpening,
      widget,
      widget: {
        boxes,
        imageCount,
        imageSize,
        utmContent,
        utmMedium,
        utmSource
      }
    } = this.props

    if (!boxes.length) {
      return null
    }

    const textBoxes = Object.assign([], boxes)
    const headBoxes = textBoxes.splice(0, imageCount)

    return (
      <WidgetContainer widget={widget} isOpening={isOpening}>
        {
          headBoxes.length > 0 &&
          <ImageRow>
            {
              headBoxes.map(box => {
                const {
                  featuredType,
                  guid,
                  images,
                  link,
                  source,
                  title
                } = box

                const imagePath = images[imageSize]
                const image = (imagePath.indexOf('http://') === -1 && imagePath.indexOf('https://') === -1)
                  ? `${UNVERSIONED_STATICS_PATH}${images[imageSize]}`
                  : images[imageSize]

                const utmLink = new UTM(link).getUTMLink({
                  utmContent,
                  utmMedium,
                  utmSource,
                  utmTerm: `position-${boxes.indexOf(box)}`,
                  utmCampaign: source
                })

                return (
                  <RegularCol key={guid}>
                    <ArticleImageBox
                      featuredType={featuredType}
                      image={image}
                      imageClass={`image-${imageSize}`}
                      isImage={true}
                      link={utmLink}
                      title={title}
                    />
                  </RegularCol>
                )
              })
            }
          </ImageRow>
        }
        {
          textBoxes.length > 0 &&
          <RegularRow>
            <RegularCol>
              <ArticleList>
                {
                  textBoxes.map(box => {
                    const {
                      featuredType,
                      guid,
                      link,
                      source,
                      title
                    } = box

                    const utmLink = new UTM(link).getUTMLink({
                      utmContent,
                      utmMedium,
                      utmSource,
                      utmTerm: `position-${boxes.indexOf(box)}`,
                      utmCampaign: source
                    })

                    return (
                      <ArticleListBox
                        featuredSize='inline'
                        featuredType={featuredType}
                        key={guid}
                        link={utmLink}
                        title={title}
                      />
                    )
                  })
                }
              </ArticleList>
            </RegularCol>
          </RegularRow>
        }
      </WidgetContainer>
    )
  }
}
